import Vue from 'vue'
import { BootstrapVue } from 'bootstrap-vue'

import VCalendar from 'v-calendar';

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faArrowLeft,
  faArrowRight,
  faCar,
  faCheckSquare,
  faChevronCircleDown,
  faCircle as faCircleSolid,
  faDog,
  faFlower,
  faFlowerDaffodil as fasFlowerDaffodil,
  faMapMarker as fasMapMarker,
  faMugTea,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faCheck,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faCircle as faCircleRegular,
  faClock,
  faDirections,
  faFlowerDaffodil as farFlowerDaffodil,
  faLocation,
  faMapMarker,
  faMapMarkerAlt,
  faSearch,
  faSearchMinus,
  faSlidersH,
  faTimes,
  faTree,
  faTrees,
  faWheelchair,
  faWifi,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faChevronRight as faChevronRightLight,
  faChevronLeft as faChevronLeftLight,
  faCircle as faCircleLight,
  faInfoCircle,
  faList,
  faMap,
  faSquare,
} from '@fortawesome/pro-light-svg-icons';
import {
  faFacebookF,
  faTwitter,
} from '@fortawesome/free-brands-svg-icons';
import {
  faFlower as fadFlower,
  faSpinner as fadSpinner,
} from '@fortawesome/pro-duotone-svg-icons';

import App from './App'
import router from './router'
import store from './store'

import '@/assets/scss/main.scss'

if (process.env.VUE_APP_ENVIRONMENT === 'production') {
  import('@/services/gtm').then();
}

library.add(
  faArrowLeft,
  faArrowRight,
  faCar,
  faCheck,
  faCheckSquare,
  faChevronCircleDown,
  faChevronDown,
  faChevronRight,
  faChevronRightLight,
  faChevronLeft,
  faChevronLeftLight,
  faCircleLight,
  faCircleRegular,
  faCircleSolid,
  faClock,
  faDog,
  faDirections,
  faFacebookF,
  faFlower,
  fadFlower,
  farFlowerDaffodil,
  fasFlowerDaffodil,
  faInfoCircle,
  faList,
  faLocation,
  faMap,
  fasMapMarker,
  faMapMarker,
  faMapMarkerAlt,
  faMugTea,
  faSearch,
  faSearchMinus,
  faSlidersH,
  fadSpinner,
  faSquare,
  faTimes,
  faTree,
  faTrees,
  faTwitter,
  faWheelchair,
  faWifi,
)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

Vue.use(BootstrapVue)

Vue.use(require('vue-moment'));

Vue.use(VCalendar, {
  componentPrefix: 'vc',
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
